import { useMultiWindowAwareLocalStorage } from '../../hooks/useStorage'

export function useDarkModeStorage() {
  return useMultiWindowAwareLocalStorage(__STORAGE_KEY_PREFIX__, 'darkmode', false)
}
